var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.VPopup,
    {
      staticClass: "cie-panel",
      attrs: { fixed: "", "auto-close": false, "esc-close": true },
      model: {
        value: _setup.panelVisible,
        callback: function ($$v) {
          _setup.panelVisible = $$v
        },
        expression: "panelVisible",
      },
    },
    [
      _c(
        "div",
        { staticClass: "cie-header", on: { pointerdown: _setup.onDragStart } },
        [
          _c("h3", [_vm._v("评论图片下载")]),
          _vm._v(" "),
          _c("div", { staticClass: "cie-header-actions" }, [
            _c(
              "button",
              {
                staticClass: "cie-close-button",
                attrs: { type: "button", title: "关闭" },
                on: {
                  click: function ($event) {
                    _setup.panelVisible = false
                  },
                },
              },
              [_vm._v("\n        ×\n      ")]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "cie-stats" }, [
        _vm._v(_vm._s(_setup.statsText)),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "cie-download-all",
          attrs: { type: "button", disabled: _setup.items.length === 0 },
          on: { click: _setup.downloadAllComments },
        },
        [_vm._v("\n    全部下载\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cie-content" },
        [
          _setup.items.length === 0
            ? _c("p", { staticClass: "cie-empty" }, [
                _vm._v("暂无包含图片的评论"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_setup.items, function (item) {
            return _c(
              "button",
              {
                key: item.commentId,
                staticClass: "cie-item",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _setup.downloadSingleComment(item)
                  },
                },
              },
              [
                _c("div", { staticClass: "cie-item-content" }, [
                  _c("div", { staticClass: "cie-item-info" }, [
                    _c("span", { staticClass: "cie-item-username" }, [
                      _vm._v(_vm._s(item.userName)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "cie-item-message",
                        attrs: { title: item.content },
                      },
                      [_vm._v(_vm._s(_setup.truncate(item.content)))]
                    ),
                    _vm._v(" "),
                    item.time
                      ? _c("span", { staticClass: "cie-item-time" }, [
                          _vm._v(_vm._s(_setup.formatTimestamp(item.time))),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "cie-item-count" }, [
                    _vm._v("[" + _vm._s(item.pictures.length) + "张]"),
                  ]),
                ]),
              ]
            )
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }